import React, { FC, useContext } from 'react';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';
import { apiLicense } from '../../resources/api/apiLicense';
import { OrganizationContext } from '../../contexts/OrganizationContext';
import { UserContext } from '../../contexts/UserContext';
import { useDialog } from '../../hooks/useDialog';
import { Link } from 'react-router-dom';
import { AssignLicensesDialog } from '../AssignLicenses/AssignLicensesDialog';

const { useAssignLicense } = apiLicense;

export const AssignLicensesButton: FC = () => {
  const { t } = useTranslation();
  const { organization } = useContext(OrganizationContext);

  const { user } = useContext(UserContext);

  const { Guard } = useAssignLicense(organization ?? void 0, user?.id);

  const { isOpen, openUrl, close } = useDialog('assign');

  return (
    <Guard>
      <Button component={Link} to={openUrl} variant={'contained'}>
        {t('user.assignLicensesButton')}
      </Button>

      <AssignLicensesDialog open={isOpen} closeDialog={close} />
    </Guard>
  );
};
